import {SlideBase} from './SlideBase';
import {SlideProps} from './tipos';
import {logoUrl, LOGOS, PLATAFORMAS_STREAMING} from './dados';
import {Midia} from '../midia';

export function SlideStreaming({vertical}: SlideProps) {
	return (
		<SlideBase vertical={vertical} variante="escuro">
			<div className="slide-streaming">
				<div className="slide-titulo">
					<span className="slide-sobretitulo">Netcomet TV+</span>
					<h1>Internet + diversão</h1>
					<p>Filmes, séries, futebol e música. Tudo no mesmo plano.</p>
				</div>
				<div className="slide-streaming-grid">
					{PLATAFORMAS_STREAMING.map((id, i) => (
						<div key={id} className="slide-streaming-tile" style={{animationDelay: `${i * 0.25}s`}}>
							<Midia src={logoUrl(id)} alt={LOGOS[id].nome}/>
						</div>
					))}
				</div>
				<p className="slide-rodape-nota">Verifique a disponibilidade no seu plano.</p>
			</div>
		</SlideBase>
	);
}
